import React, { useState } from "react";
import {
  calculateIPRToothForNegation,
  teeth3DControlsObjectByJaw,
  teeth3DControlsObjectByName,
  toothMovementTypes,
  undoMovementList,
} from "./teethControls/TeethPositionHelper";
import { useGlobalStore } from "@/store";
import { EditIPR, EditSpacing, ExistingAtt, Ipr } from "./Icons";
import { attachmentTypes } from "./teethControls/AttachmentSelector";
import { useModal } from "@/hooks/useModal";
import { redoMovementList } from "./teethControls/TeethPositionHelper";
import { numberingUniversal } from "@/helpers/teethNumbering";
import { getParams } from "@/helpers/getParams";
import { PencilIcon } from "./Icons";
import {
  getAdjacentTeeth,
  isLeftShiftDown,
  prepareRedoListToExport,
  setIsLeftShiftDown,
} from "./teethControls/TeethControls";
import { StartRevision } from "@/mixpanel/Mixpanel";
import {
  TranslationComponent,
  useCustomTranslation,
} from "@/hooks/useTranslation";
import { addRemovedPonticTeeth, removePonticTeeth } from "./controls/Pontics";
import {
  prepareAttachment3DControlslisteners,
  prepareAttachmentsUtilities,
  setDeletedAtt,
  setIsUIHold,
  resetSelectedTooth,
  setSelectedAtt,
  setIsReset,
  getIsReset,
} from "./teethControls/addRemoveAttachment";
import { addEventListener, clearAllListeners } from "@/helpers/clickManager";
import {
  customTeethGizmoControls,
  getIsCameraDragging,
  isCameraDragging,
  setOrbitControlsEnabled,
} from "./Camera";
import {
  FETreatmentGeneration,
  heatMapManager,
  replaceLastStepWithLastOriginalStep,
} from "./Mesh";
import { CreateLowResolutionTeethFromGum } from "./ObjectSimplifier";
import {
  deleteCloseOptions,
  deleteEditingPanels,
  prepareIPRs3DControls,
  set3DControlsVariables,
  setIprOverlays as setGlobalIprOverLays,
  iprOverLays as globalIprOverLays,
  setShow3DControls,
} from "@/helpers/ipr";
import { isAutoAdjustOn } from "./AutoAdjust";
import { globalData, setToggle } from "../../helpers/globData.ts";
import { setIsBiteJumpActive } from "./Bitejump.ts";
import { reassignOriginalIPRs } from "../../helpers/ipr.js";

let globalIsUI = false;
export let isWriting = false;
export let isMouseDown = false;

export function setIsWritting(state) {
  isWriting = state;
}

//console.log(Object.values(logs), Object.keys(logs));
/**
 *
 * @param {string} toothKey movement tooth key
 * @param {string} movementKey Teeth Movement Types
 * @param {int} value the movement amount
 * @returns {string} the actual movement name
 */
function getMovementName(toothKey, movementKey, value) {
  const toothQuarter = getToothQuarter(Number(toothKey.match(/[0-9]+/)));
  if (toothQuarter === 5) {
    return "incorrect_tooth_key";
  }
  switch (movementKey) {
    case "Extrusion/Intrusion":
      if (value > 0) {
        if (toothQuarter <= 2) {
          return "intrusion";
        } else if (toothQuarter <= 4) {
          return "extrusion";
        }
      } else {
        if (toothQuarter <= 2) {
          return "extrusion";
        } else if (toothQuarter <= 4) {
          return "intrusion";
        }
      }
    case "Buccal/Lingual":
      if (value > 0) {
        return "buccal_translation";
      } else {
        return "lingual_translation";
      }
    case "Mesial/Distal":
      if (value > 0) {
        return "distal_translation";
      } else {
        return "mesial_translation";
      }
    case "Rotation":
      if (value > 0) {
        if (toothQuarter === 1 || toothQuarter === 4) {
          return "mesial_in_rotation";
        } else if (toothQuarter === 2 || toothQuarter === 3) {
          return "distal_in_rotation";
        }
      } else {
        if (toothQuarter === 1 || toothQuarter === 4) {
          return "distal_in_rotation";
        } else if (toothQuarter === 2 || toothQuarter === 3) {
          return "mesial_in_rotation";
        }
      }
    case "Inclination":
      if (value > 0) {
        if (toothQuarter <= 2) {
          return "buccal_inclination";
        } else if (toothQuarter <= 4) {
          return "lingual_inclination";
        }
      } else {
        if (toothQuarter <= 2) {
          return "lingual_inclination";
        } else if (toothQuarter <= 4) {
          return "buccal_inclination";
        }
      }
    case "Angulation":
      if (value > 0) {
        if (toothQuarter === 2 || toothQuarter === 4) {
          return "distal_crown_angulation";
        } else if (toothQuarter === 1 || toothQuarter === 3) {
          return "mesial_crown_angulation";
        }
      } else {
        if (toothQuarter === 2 || toothQuarter === 4) {
          return "mesial_crown_angulation";
        } else if (toothQuarter === 1 || toothQuarter === 3) {
          return "distal_crown_angulation";
        }
      }
    case "LeftHinge":
      if (value > 0) {
        if (toothQuarter === 2 || toothQuarter === 3) {
          return "distal_in_hinge";
        } else if (toothQuarter === 1 || toothQuarter === 4) {
          return "distal_out_hinge";
        }
      } else {
        if (toothQuarter === 2 || toothQuarter === 3) {
          return "distal_out_hinge";
        } else if (toothQuarter === 1 || toothQuarter === 4) {
          return "distal_in_hinge";
        }
      }
    case "RightHinge":
      if (value > 0) {
        if (toothQuarter === 2 || toothQuarter === 3) {
          return "mesial_out_hinge";
        } else if (toothQuarter === 1 || toothQuarter === 4) {
          return "mesial_in_hinge";
        }
      } else {
        if (toothQuarter === 2 || toothQuarter === 3) {
          return "mesial_in_hinge";
        } else if (toothQuarter === 1 || toothQuarter === 4) {
          return "mesial_out_hinge";
        }
      }
    default:
      "movement_key_is_not_found";
  }
}

/**
 * @param {int} toothNumber the Universal tooth number
 * @returns {int} 1 => LU, 2 => RU, 3 => RL, 4 => LL, 5 => wrong tooth number
 */
function getToothQuarter(toothNumber) {
  if (toothNumber < 9) {
    return 1;
  } else if (toothNumber < 17) {
    return 2;
  } else if (toothNumber < 25) {
    return 3;
  } else if (toothNumber < 33) {
    return 4;
  } else {
    return 5;
  }
}

const lowResolutionTeethPercentage = 95;
const multipleTeethSelectionModeKeyCodes = ["ShiftLeft", "ShiftRight"];
function ReviseTreatment({
  reset,
  clearAutoSave,
  isViewerControlsEnabled,
  startTracking,
  TPdata,
  setAutoSave,
  iprOverLays,
  setIprOverlays,
  maxStepNumber,
}) {
  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };
  const { dentalNotation } = getParams();
  const {
    logs,
    isMobile,
    setStepperControls,
    setControls3D,
    setLogs,
    show3DControls,
    showContModification,
    groupRef,
    groupRef2,
    currentStep,
    isUI,
    isTranslator,
  } = useGlobalStore(state => ({
    logs: state.logs,
    isMobile: state.layoutConfig.isMobile,
    show3DControls: state.toggle.show3DControls,
    showContModification: state.toggle.showContModification,
    setLogs: state.setLogs,
    setToggle: setToggle,
    setControls3D: state.setControls3D,
    groupRef: state.refs.groupRef,
    groupRef2: state.refs.groupRef2,
    currentStep: state.stepperControls.currentStep,
    isUI: state.isUI,
    setStepperControls: state.setStepperControls,
    isTranslator: state.layoutConfig.isTranslator,
  }));
  if (!globalIprOverLays) {
    setGlobalIprOverLays(iprOverLays);
  }
  globalIsUI = isUI;
  const { ModalContainer: SubmitModal, toggleModal: toggleSubmit } = useModal();
  const { ModalContainer: DiscardModal, toggleModal: toggleDiscard } =
    useModal();

  const [revisionNotes, setRevisionNotes] = useState("");
  const sendMessage = async () => {
    // track data in mixpanal
    trackDataInMixPanal("Submitted");
    let newArray = JSON.parse(JSON.stringify(logs));
    reset();
    prepareRedoListToExport(redoMovementList);
    let message = {
      logs: newArray,
      revisionNotes,
      reviseTreatment: false,
      controlsRedoList: redoMovementList,
    };
    message = JSON.parse(JSON.stringify(message));
    parent.postMessage(message, "*");

    toggleSubmit();
    setControls3D("selectedTooth", null);
    customTeethGizmoControls.setIsEnabled(false);
    setLogs({});
    redoMovementList.splice(0, redoMovementList.length);
    clearAutoSave();
    reassignOriginalIPRs([
      groupRef.current.children[maxStepNumber].children[0],
      groupRef.current.children[maxStepNumber].children[1],
    ]);
    setToggle("startRevision", false);
    setToggle("show3DControls", false);
    setShow3DControls(false);
  };

  const trackDataInMixPanal = action => {
    let newArray = JSON.parse(JSON.stringify(logs));
    let message = {
      logs: newArray,
      revisionNotes,
    };
    message = JSON.parse(JSON.stringify(message));
    // track data in mixpanal
    StartRevision(message, TPdata, action);
  };
  const toothLogs = Object.keys(logs).map(toothKey => {
    if (toothKey.includes("Movement")) {
      const toothData = logs[toothKey];

      // Check if all values in the toothData object are equal to 0 or an empty string
      const allValuesAreZeroOrEmpty = Object.values(toothData).every(
        value => value === 0 || value === "",
      );

      // If all values are zero or empty, skip rendering this tooth
      if (allValuesAreZeroOrEmpty) {
        return null;
      }
      // Create an array of JSX elements for each key-value pair in toothData
      const toothDataEntries = Object.entries(toothData)
        .map(([key, value], idx) => {
          const svg = toothMovementTypes.find(
            typeObj => typeObj.type === key,
          )?.svg;
          if (key === "attachment") {
            if (
              toothData?.["attachment"] &&
              Object.keys(toothData?.["attachment"])?.length > 0
            ) {
              return Object.entries(toothData?.[key]).map(
                ([key2, value], i) => {
                  let text = value["action"];
                  if (text === "" || text === "No action done") return;
                  return (
                    <React.Fragment key={key2}>
                      <div className="attachment_log flex items-center gap-1">
                        {attachmentTypes.map((elem, index) => {
                          if (
                            elem.name === value["type"] ||
                            elem.name === toothData?.[key]?.["type"] ||
                            elem.name === toothData?.["attachment"]?.["type"]
                          ) {
                            return (
                              <React.Fragment key={index}>
                                {elem.svg}
                              </React.Fragment>
                            );
                          } else if (
                            (value["action"] === "remove" ||
                              value["action"] === "remove" ||
                              toothData?.[key]?.["action"] === "remove" ||
                              toothData?.["attachment"]?.["action"] ===
                                "remove") &&
                            index === 0
                          ) {
                            return <ExistingAtt key={i} />;
                          }
                        })}
                        <div>{getContent("labels", `attachment_${text}`)}</div>
                      </div>
                    </React.Fragment>
                  );
                },
              );
            } else {
              if (toothData[key]) {
                return (
                  <React.Fragment key={key}>
                    <div className="attachment_log flex items-center gap-1">
                      {attachmentTypes.map((elem, i) => {
                        if (elem.name === toothData[key]["type"]) {
                          return elem.svg;
                        }
                      })}
                      <div>
                        {getContent(
                          "labels",
                          `attachment_${toothData[key]["action"]}`,
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                );
              }
            }
          } else {
            return (
              value !== 0 &&
              value !== "" && (
                <React.Fragment key={key}>
                  <div className="flex gap-1">
                    {svg && <div>{svg}</div>}
                    <div className="capitalize">
                      {Math.abs(value)}
                      {idx !== Object.entries(toothData).length - 1 && ","}
                    </div>
                    <div className="capitalize">
                      {getContent(
                        "labels",
                        getMovementName(toothKey, key, value),
                      )}
                    </div>
                  </div>
                </React.Fragment>
              )
            );
          }
        })
        .filter(Boolean);
      if (
        (toothData?.["attachment"] &&
          Object.keys(toothData?.["attachment"]).length > 0 &&
          Object.values(toothData?.["attachment"]).every(
            attachment => attachment?.["action"] === "",
          )) ||
        toothData?.["attachment"]?.["action"] === "" ||
        toothData?.["attachment"]?.["action"] === "No action done"
      ) {
        return;
      } else {
        return (
          <div key={toothKey} className="flex flex-col gap-2">
            <div style={{ color: "#717171" }} className="text-xs font-bold">
              {`${getContent("labels", "tooth")} ${
                numberingUniversal?.[Number(toothKey.split("_")[0])][
                  dentalNotation
                ]
              } ${getContent("labels", "adjusted")}`}
            </div>
            <div className="font-sm flex flex-col gap-3 font-normal">
              {toothDataEntries}
            </div>
          </div>
        );
      }
    }
  });
  const iprSpacingLogs = Object.keys(logs).map(toothKey => {
    if (!toothKey.includes("Movement")) {
      const toothData = logs[toothKey];

      const typeText = toothData["type"]
        ? toothData.type === 1
          ? "ipr"
          : "spacing"
        : "";
      if (Math.abs(Number(toothData.amount).toFixed(2) == 0)) {
        return;
      }
      const icon =
        Math.abs(Number(toothData.amount)).toFixed(2) > 0.01 ? (
          <EditIPR />
        ) : (
          <EditSpacing />
        );
      let text;
      if (toothData["type"]) {
        if (
          isNaN(toothData.amount) ||
          Math.abs(Number(toothData.amount)).toFixed(2) < 0.1
        ) {
          return;
        }
        if (toothData.action == "added" || toothData.action == "deleted") {
          text = (
            <div key={toothKey}>
              {`${
                Math.abs(Number(toothData?.amount)).toFixed(2) +
                " " +
                getContent(
                  "labels",
                  `${typeText}_${toothData.action}_between`,
                ) +
                " " +
                numberingUniversal[
                  toothData.from.includes("t")
                    ? Number(toothData.from.split("t")[1])
                    : Number(toothData.from)
                ][dentalNotation] +
                " " +
                getContent("labels", "and") +
                " " +
                numberingUniversal[
                  toothData.to.includes("t")
                    ? Number(toothData.to.split("t")[1])
                    : Number(toothData.to)
                ][dentalNotation]
              }`}
            </div>
          );
        } else if (toothData.action == "changed") {
          // not used as hamzeh and othman said
          text = (
            <div key={toothKey}>
              {`${
                typeText +
                " " +
                toothData.action +
                "from" +
                " " +
                "<s>{Math.abs(toothData.preAmount)}</s>" +
                " " +
                Math.abs(Number(toothData.amount)).toFixed(2) +
                " " +
                toothData.action +
                " " +
                "between" +
                " " +
                numberingUniversal[
                  toothData.from.includes("t")
                    ? Number(toothData.from.split("t")[1])
                    : Number(toothData.from)
                ][dentalNotation] +
                " " +
                "and" +
                " " +
                numberingUniversal[
                  toothData.to.includes("t")
                    ? Number(toothData.to.split("t")[1])
                    : Number(toothData.to)
                ][dentalNotation]
              }`}
            </div>
          );
        }
      }

      return (
        <div key={toothKey} className="font-sm flex flex-col gap-3 font-normal">
          <div
            className="font-sm grid font-normal"
            style={{ gridTemplateColumns: "auto 1fr", gap: "8px" }}
          >
            {icon}
            {text}
          </div>
        </div>
      );
    }
  });
  const enable3DControls = true;
  const disabledSubmit =
    undoMovementList.length === 0 && revisionNotes.length === 0;

  return (
    <>
      <SubmitModal
        title={getContent("labels", "submit_modifications")}
        primaryAction={() => {
          sendMessage();
          setToggle("showContModification", false);
          customTeethGizmoControls.setIsEnabled(false);
        }}
        primaryActionText={getContent("actions", "submit")}
        secondaryActionText={getContent("actions", "cancel")}
      >
        {
          <div
            dangerouslySetInnerHTML={{
              __html: getContent("labels", "confirmation_submit"),
            }}
          />
        }
      </SubmitModal>
      <DiscardModal
        title={getContent("labels", "discard_modifications")}
        primaryAction={() => {
          if (heatMapManager) {
            heatMapManager.active3DControls = false;
          }
          trackDataInMixPanal("Discarded");
          setToggle("startRevision", false);
          setToggle("show3DControls", false);
          setShow3DControls(false);

          setLogs({});
          redoMovementList.splice(0, redoMovementList.length);
          setControls3D("selectedTooth", null);
          setSelectedAtt(null);

          customTeethGizmoControls.setIsEnabled(false);
          reset();
          addRemovedPonticTeeth(groupRef, currentStep);
          clearAutoSave();
          clearAllListeners(1);
          resetSelectedTooth();
          reassignOriginalIPRs([
            groupRef.current.children[maxStepNumber].children[0],
            groupRef.current.children[maxStepNumber].children[1],
          ]);
          FETreatmentGeneration.moveToStep(globalData.maxStepNumber);
          setToggle("showContModification", false);
        }}
        primaryActionText={getContent("actions", "discard")}
        secondaryActionText={getContent("actions", "cancel")}
      >
        {getContent(
          "labels",
          "discard_3d_modifications_and_return_to_previous_treatment_review",
        )}
      </DiscardModal>
      <div
        className="controls grid w-[258px] grid-rows-[auto,1px,1fr,auto] bg-white px-4 py-6"
        style={{
          backgroundColor: "#FFFFFF",
          width: "258px",
          height: isTranslator ? "calc(100% - 160px)" : "calc(100% - 80px)",
          ...(isTranslator && {
            top: "80px",
            position: "absolute",
            right: "10px",
          }),
          display: "grid",
          gridTemplateRows: "auto 1px 1fr",
        }}
      >
        <TranslationComponent group={"controls"} color={"secondary"} />
        <div
          id="revision_notes"
          className="pb-2 text-start text-base font-medium"
        >
          {getContent("actions", "revise_treatment")}
        </div>
        <div className="bounty_divider" />
        <div className="flex flex-col py-2">
          {isViewerControlsEnabled &&
          !isMobile &&
          !show3DControls &&
          !showContModification ? (
            <div
              className="mb-[16px] mt-[8px] flex cursor-pointer justify-center rounded-[3px] border-2 border-[#009ACE] px-[12px] py-[8px]"
              onClick={() => {
                setControls3D("is3DControlsLoaded", true);

                if (heatMapManager) {
                  heatMapManager.active3DControls = true;
                }
                setStepperControls("currentStep", maxStepNumber);
                setStepperControls("storedStep", maxStepNumber);
                FETreatmentGeneration.moveToStep(maxStepNumber);

                // groupRef.current.children[currentStep].children[0].visible =
                //   false;
                // groupRef.current.children[currentStep].children[1].visible =
                //   false;

                // replaceLastStepWithLastOriginalStep(groupRef, groupRef2);

                set3DControlsVariables(
                  logs,
                  iprOverLays,
                  setLogs,
                  setIprOverlays,
                  setAutoSave,
                  getContent,
                );
                // customTeethGizmoControls.setIsEnabled(true);
                setTimeout(() => {
                  CreateLowResolutionTeethFromGum(
                    groupRef.current.children[maxStepNumber].children[0],
                    lowResolutionTeethPercentage,
                  );
                  CreateLowResolutionTeethFromGum(
                    groupRef.current.children[maxStepNumber].children[1],
                    lowResolutionTeethPercentage,
                  );

                  const allTeethLastStep = [
                    ...groupRef.current.children[maxStepNumber].children[0]
                      .children,
                    ,
                    ...groupRef.current.children[maxStepNumber].children[1]
                      .children,
                  ];
                  allTeethLastStep.forEach(tooth => {
                    teeth3DControlsObjectByName[tooth.name] = tooth;
                    teeth3DControlsObjectByJaw[tooth.userData["jaw"]].push(
                      tooth,
                    );
                  });

                  const anotherStartTime = Date.now();
                  for (let isLower = 0; isLower < 2; isLower++) {
                    for (
                      let toothIndex = 0;
                      toothIndex <
                      groupRef.current.children[maxStepNumber].children[isLower]
                        .children.length;
                      toothIndex++
                    ) {
                      calculateIPRToothForNegation(
                        groupRef.current.children[maxStepNumber].children[
                          isLower
                        ].children[toothIndex],
                        1,
                      );
                    }
                  }
                  /* console.log(
                    Date.now() - anotherStartTime,
                    "this is AA preparation time",
                  ); */

                  prepareAttachment3DControlslisteners([
                    groupRef.current.children[maxStepNumber].children[0],
                    groupRef.current.children[maxStepNumber].children[1],
                  ]);
                  if (heatMapManager) {
                    heatMapManager.executeTaskImmediatelyAfterTime(
                      groupRef.current.children[maxStepNumber].children[0]
                        .children,
                      groupRef.current.children[maxStepNumber].children[1]
                        .children,
                      150,
                      FETreatmentGeneration.controlsHeatmaps,
                    );
                  }

                  setControls3D("is3DControlsLoaded", false);

                  setToggle("show3DControls", true);
                }, 0.5);

                removePonticTeeth(groupRef, maxStepNumber);
                prepareIPRs3DControls(
                  [
                    groupRef.current.children[maxStepNumber].children[0],
                    groupRef.current.children[maxStepNumber].children[1],
                  ],
                  iprOverLays,
                  true,
                );

                prepareAttachmentsUtilities(
                  logs,
                  setAutoSave,
                  setLogs,
                  setControls3D,
                );

                customTeethGizmoControls.prepare3DControlsMovement(
                  logs,
                  setAutoSave,
                  setLogs,
                  setIprOverlays,
                );

                addEventListener(null, "mousemove", () => {
                  deleteEditingPanels(getContent);
                });

                addEventListener(null, "mouseup", () => {
                  isMouseDown = false;
                  setOrbitControlsEnabled(true);
                  setTimeout(() => {
                    setDeletedAtt(null);
                    setIsUIHold(false);
                  }, 10);
                });
                addEventListener(null, "mousedown", () => {
                  isMouseDown = true;
                  deleteCloseOptions();
                  if (!globalIsUI) {
                    setSelectedAtt(null);
                    setIsReset(true);
                    setTimeout(() => {
                      if (getIsReset() && !getIsCameraDragging()) {
                        resetSelectedTooth();
                      }
                    }, 0.01);
                  }
                });
                addEventListener(null, "keydown", key => {
                  if (
                    multipleTeethSelectionModeKeyCodes.indexOf(key.code) > -1
                  ) {
                    if (!isLeftShiftDown && !isAutoAdjustOn) {
                      setIsLeftShiftDown(true);
                    }
                  }
                });

                addEventListener(null, "keyup", key => {
                  if (
                    multipleTeethSelectionModeKeyCodes.indexOf(key.code) > -1
                  ) {
                    if (isLeftShiftDown && !isAutoAdjustOn) {
                      setIsLeftShiftDown(false);
                    }
                  }
                });

                setToggle("biteJump", false);
                setIsBiteJumpActive(false);

                // setToggle("grid", false);

                setShow3DControls(true);

                startTracking();
              }}
            >
              <PencilIcon />
              <div className="text-base font-medium text-[#009ACE]">
                {getContent("actions", "modify_plan")}
              </div>
            </div>
          ) : (
            <></>
          )}
          <label
            className="mb-2 text-left text-xs font-bold text-[#717171]"
            htmlFor="postContent"
          >
            {getContent("labels", "comments_to_technicians")}
          </label>
          <textarea
            onChange={e => setRevisionNotes(e.target.value)}
            onFocus={() => {
              setIsWritting(true);
            }} // Focus event handler
            onBlur={() => {
              setIsWritting(false);
            }} // Blur event handler
            name="postContent"
            placeholder={getContent(
              "labels",
              "add_your_revision_notes_and_comments_here",
            )}
            id="postContent"
            className="min-h-[100px] flex-1 p-2 placeholder:text-sm placeholder:font-medium placeholder:text-[#c5c5c5]"
          />
        </div>
        <div
          id="change_log"
          className="bounty-scrollbar overflow-y-auto overflow-x-hidden"
        >
          <div className="flex flex-col gap-4">{toothLogs}</div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              {iprSpacingLogs[0] && (
                <div style={{ color: "#717171" }} className="text-xs font-bold">
                  {getContent("labels", "ipr_and_spacing")}
                </div>
              )}
              {iprSpacingLogs}
            </div>
          </div>
          {Object.keys(logs).length === 0 && (
            <div className="pt-4 text-sm font-normal">
              {getContent(
                "labels",
                "your_modifications_will_appear_here_once_you_make_one",
              )}
            </div>
          )}
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <div
            className="grid text-center text-sm font-bold"
            style={{
              width: "94px",
              height: "37px",
              border: "1px solid #BCBCBC",
              borderRadius: "3px",
              color: "#666666",
            }}
          >
            <button
              onClick={toggleDiscard}
              style={{
                cursor: "pointer",
              }}
            >
              {getContent("actions", "discard")}
            </button>
          </div>
          <div
            className="grid text-center text-sm font-bold"
            style={{
              backgroundColor: disabledSubmit ? "#D4D4D4" : "#009ACE",
              color: "#FFF",
              width: "94px",
              height: "37px",
              border: "1px solid #BCBCBC",
              borderRadius: "3px",
            }}
          >
            <button
              onClick={disabledSubmit ? undefined : toggleSubmit}
              style={{
                cursor: disabledSubmit ? "not-allowed" : "pointer",
              }}
            >
              {getContent("actions", "send")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviseTreatment;
